<template>
    <ProgressBar v-if="resIsLoading === true" mode="indeterminate" style="height: 6px"></ProgressBar>
    <div v-else>
        <!-- Toggle Switch pour basculer entre les formulaires -->
        <div class="toggle-container mb-3">
            <div class="toggle-label">
                {{ formMode === 'normal' ? 'Louer un véhicule' : 'Envoyer un colis' }}
            </div>
            <div class="toggle-button-cover">
                <div id="button-3" class="button r">
                    <input class="checkbox" type="checkbox" v-model="formSwitch" @change="toggleFormMode">
                    <div class="knobs"></div>
                    <div class="layer"></div>
                </div>
            </div>
        </div>

        <!-- Formulaire normal -->
        <form v-if="formMode === 'normal'" @submit.prevent="createLine()">
            <div class="form-row">
                <div class="form-group col-md-6">
                    <label id="tableLabel" class="badge">Départ</label>
                    <div class="select-container">
                        <select class="custom-select" v-model="adresse_chargement_id" @change="updateAdresseChargement"
                            required>
                            <option value="" disabled selected>Sélectionnez une adresse de départ</option>
                            <option v-for="(item, index) in adresses" :key="index" :value="index">{{ item.libelle }}
                            </option>
                        </select>
                        <span class="arrow"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-chevron-down-icon lucide-chevron-down">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="form-group col-md-6">
                    <label id="tableLabel" class="badge">Arrivée</label>
                    <div class="select-container">
                        <select class="custom-select" v-model="adresse_dechargement_id"
                            @change="updateAdresseDechargement" required>
                            <option value="" disabled selected>Sélectionnez une adresse d'arrivée</option>
                            <option v-for="(item, index) in adresses" :key="`dest-${index}`" :value="index">{{
                                item.libelle }}</option>
                        </select>
                        <span class="arrow"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-chevron-down-icon lucide-chevron-down">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </span>
                    </div>
                </div>
                
                <div class="form-group col-md-6">
                    <label class="badge">Tonnage</label>
                    <div class="select-container">
                        <select class="custom-select" v-model="form.types_vehicules" required>
                            <option v-for="type in types_vehicules" :key="type.id">
                                {{ type.libelle }}
                            </option>
                        </select>
                        <span class="arrow"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-chevron-down-icon lucide-chevron-down">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </span>
                    </div>

                </div>
                <div class="form-group col-md-6">
                    <label class="badge">Marchandise à transporter</label>
                    <div class="select-container">
                        <select class="custom-select" v-model="type_marchandise" required @change="setMarchandise()">
                            <option v-for="type in types_marchandises" :key="type.id">
                                {{ type.libelle }}
                            </option>
                            <option>Autres</option>
                        </select>
                        <span class="arrow"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-chevron-down-icon lucide-chevron-down">
                                <path d="m6 9 6 6 6-6" />
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="form-group col-md-6" v-if="type_marchandise == 'Autres'">
                    <label class="badge">Préciser la marchandise</label>

                    <input type="text" v-model="form.type_marchandise" class="form-input-custom" required>

                </div>
                <div class="date-input-container col-md-6">
                    <label class="badge">Date de départ<span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input ref="dateInput" type="date" v-model="form.date_chargement" class="custom-date-input"
                            required @click="showDatePicker">
                        <div class="icon-container" @click="showDatePicker">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-calendar-icon lucide-calendar">
                                <path d="M8 2v4" />
                                <path d="M16 2v4" />
                                <rect width="18" height="18" x="3" y="4" rx="2" />
                                <path d="M3 10h18" />
                            </svg>
                        </div>
                    </div>
                </div>

            </div>

            <button type="submit" class="btn btn-rounded btn-primary btn-block highlight-btn" :disabled="isLoading">
                Rechercher un transporteur
                <span v-if="isLoading == true" class="spinner-border spinner-border-sm" role="status"
                    aria-hidden="true"></span>
            </button>
        </form>

        <!-- Formulaire avancé - DeliveryStepsForm -->
        <DeliveryStepsForm v-else />
    </div>
</template>
<script>
import $ from "jquery";
import moment from 'moment'
import AutoComplete from 'primevue/autocomplete';
import { defineComponent } from 'vue';
import DeliveryStepsForm from '@/components/DeliveryStepsForm.vue';

export default defineComponent({
    name: 'CreateDemande',
    inject: ['dialogRef'],
    components: { AutoComplete, DeliveryStepsForm },
    data() {
        return {
            resIsLoading: false,
            isLoading: false,
            table: 'demandes',
            suggestions: [],
            adresses: [],
            types_vehicules: [],
            types_marchandises: [],
            type_marchandise: null,
            baseUrl: this.$store.state.api_yams_livraisons,
            form: {
                client: this.$store.getters.user,
                utilisateur: this.$store.getters.user.name,
                date_chargement: moment().format('YYYY-MM-DD'),
                type_course: 'Aller - Retour'
            },
            adresse_chargement: null,
            adresse_dechargement: null,
            adresse_chargement_id: "", // Ajout pour gérer l'index sélectionné
            adresse_dechargement_id: "", // Ajout pour gérer l'index sélectionné
            formMode: 'normal', // Par défaut, afficher le formulaire normal
            formSwitch: false // État du switch
        }
    },
    mounted() {
        this.getAdresses()
        this.getMarchandises()
        this.getTypesVehicules()
    },
    methods: {
        // Nouvelle méthode pour basculer entre les formulaires
        toggleFormMode() {
            this.formMode = this.formSwitch ? 'advanced' : 'normal'
        },

        // Méthodes pour mettre à jour les objets adresse basées sur les indices sélectionnés
        updateAdresseChargement() {
            if (this.adresse_chargement_id !== "") {
                this.adresse_chargement = this.adresses[this.adresse_chargement_id]
            } else {
                this.adresse_chargement = null
            }
        },

        updateAdresseDechargement() {
            if (this.adresse_dechargement_id !== "") {
                this.adresse_dechargement = this.adresses[this.adresse_dechargement_id]
            } else {
                this.adresse_dechargement = null
            }
        },

        setMarchandise() {
            if (this.type_marchandise !== 'Autres') {
                this.form.type_marchandise = this.type_marchandise
            }
        },
        getAdresses() {
            this.resIsLoading = true
            this.axios.get('/api/adresses').then((response) => {
                this.adresses = response.data.data
                this.resIsLoading = false
            }).catch(() => {
                this.resIsLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        getMarchandises() {
            this.resIsLoading = true
            this.axios.get('/api/types_marchandises').then((response) => {
                this.types_marchandises = response.data.data
                this.resIsLoading = false
            }).catch(() => {
                this.resIsLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        getTypesVehicules() {
            this.resIsLoading = true
            this.axios.get('/api/types_vehicules').then((response) => {
                this.types_vehicules = response.data.data
                this.resIsLoading = false
            }).catch(() => {
                this.resIsLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        createLine() {
            this.isLoading = true
            if (this.adresse_chargement) {
                this.form.adresse_chargement = this.adresse_chargement.libelle
                this.form.ville_chargement = this.adresse_chargement.ville
                this.form.lat_chargement = this.adresse_chargement.lat
                this.form.lng_chargement = this.adresse_chargement.lng
            }

            if (this.adresse_dechargement) {
                this.form.adresse_dechargement = this.adresse_dechargement.libelle
                this.form.ville_dechargement = this.adresse_dechargement.ville
                this.form.lat_dechargement = this.adresse_dechargement.lat
                this.form.lng_dechargement = this.adresse_dechargement.lng
            }

            this.axios.post('/api/demandes', this.form).then((response) => {
                this.isLoading = false
                if (response.data.success === true) {
                    this.resetForm()
                    $('#refresh' + this.table).click()
                    this.$toast.add({
                        severity: 'success',
                        detail: response.data.message,
                        life: 3000
                    });
                    if (this.dialogRef) {
                        this.dialogRef.close()
                    }

                }
                else {
                    response.data.errors.forEach(element => {
                        this.$toast.add({
                            severity: 'warn',
                            summary: 'Oups !',
                            detail: element,
                            life: 7000
                        });
                    });
                }
            }).catch(() => {
                this.isLoading = false
                this.$toast.add({
                    severity: 'error',
                    summary: 'Probleme de connexion',
                    detail: 'Une erreur s\'est produite lors de la connexion au serveur !',
                    life: 5000
                });
            })
        },
        resetForm() {
            this.form = {
                client: this.$store.getters.user,
                utilisateur: this.$store.getters.user.name,
                date_chargement: moment().format('YYYY-MM-DD'),
                type_course: 'Aller - Retour'
            }
            this.adresse_chargement = null
            this.adresse_dechargement = null
            this.adresse_chargement_id = ""
            this.adresse_dechargement_id = ""
            this.type_marchandise = null
        },
        showDatePicker() {
            this.$refs.dateInput.showPicker();
        }
    }
})
</script>
<style scoped>
.select-container {
    position: relative;
    width: 100%;
}

.custom-select {
    background: #f0f2f5;
    border: none;
    border-radius: 8px;
    padding: 12px 40px 12px 16px;
    /* Équilibrage des paddings haut/bas */
    font-size: 14px;
    color: #1d1d1d;
    width: 100%;
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
    line-height: 1.5;
    /* Ajout d'une hauteur de ligne */
    height: auto;
    /* Hauteur automatique basée sur le contenu */
}

.form-input-custom {
    background: #f0f2f5;
    border: none;
    border-radius: 8px;
    padding: 19px 40px 7px 16px;
    /* Espace pour la flèche */
    font-size: 14px;
    color: #333;
    width: 100%;
    -webkit-appearance: none;
    /* Retirer la flèche par défaut */
    appearance: none;
    cursor: pointer;
}

.arrow {
    position: absolute;
    top: 50%;
    right: 12px;
    display: flex;
    justify-content: center;
    /* Centre horizontalement */
    align-items: center;
    /* Centre verticalement */
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 1.5px solid #ccc;
    pointer-events: none;
    transform: translateY(-50%);
}

.arrow svg {
    width: 15px;
    height: 15px;
    stroke: #333;
    stroke-width: 2;
    /* Ajustement de l'épaisseur */
}

/* Effet au survol */
.custom-select:hover,
.custom-select:focus {
    background: #e9ebef;
    outline: none;
    box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.5);
}

/* date input custom*/
.date-input-container {
    margin-bottom: 20px;
}

.input-group {
    position: relative;
    background: #f0f2f5;
    border-radius: 8px;
    overflow: hidden;
}

.custom-date-input {
    background: transparent;
    border: none;
    padding: 12px 16px;
    font-size: 14px;
    color: #333;
    width: 100%;
    cursor: pointer;
    position: relative;
    z-index: 1;
}

.icon-container {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
    border-left: 1px solid #e9ecef;
    cursor: pointer;
    z-index: 2;
}

.icon-container svg {
    width: 20px;
    height: 20px;
    stroke: #333;
    stroke-width: 2;
    /* Ajustement de l'épaisseur */
}

/* Styles critiques pour le sélecteur */
.custom-date-input::-webkit-calendar-picker-indicator {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 40px;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
}

/* Pour Firefox */
.custom-date-input {
    -moz-appearance: textfield;
}

/* Masquer les éléments indésirables */
.custom-date-input::-webkit-inner-spin-button,
.custom-date-input::-webkit-clear-button {
    display: none;
}

/* Effet au focus */
.custom-date-input:focus {
    outline: none;
    box-shadow: inset 0 0 0 2px rgba(66, 153, 225, 0.5);
}

/* Styles pour le toggle switch */
.toggle-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.toggle-label {
    margin-right: 10px;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
}

.toggle-button-cover {
    position: relative;
    width: 74px;
    height: 36px;
    box-sizing: border-box;
}

.button-cover,
.knobs,
.layer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.button {
    position: relative;
    width: 74px;
    height: 36px;
    overflow: hidden;
}

.checkbox {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
}

.knobs {
    z-index: 2;
}

.layer {
    width: 100%;
    background-color: #ebf7fc;
    transition: 0.3s ease all;
    z-index: 1;
}

.button.r,
.button.r .layer {
    border-radius: 100px;
}

#button-3 .knobs:before {
    content: "";
    position: absolute;
    top: 3px;
    left: 4px;
    width: 30px;
    height: 30px;
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    text-align: center;
    line-height: 1;
    padding: 9px 4px;
    background-color: #03a9f4;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s ease all, left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
}

/* Ajouter des icônes SVG au contenu avant */
#button-3 .knobs:before {
    content: "";
    background-color: #3242C4;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 512' fill='white'%3E%3Cpath d='M171.3 96L224 96l0 96-112.7 0 30.4-75.9C146.5 104 158.2 96 171.3 96zM272 192l0-96 81.2 0c9.7 0 18.9 4.4 25 12l67.2 84L272 192zm256.2 1L428.2 68c-18.2-22.8-45.8-36-75-36L171.3 32c-39.3 0-74.6 23.9-89.1 60.3L40.6 196.4C16.8 205.8 0 228.9 0 256L0 368c0 17.7 14.3 32 32 32l33.3 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l130.7 0c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80l33.3 0c17.7 0 32-14.3 32-32l0-48c0-65.2-48.8-119-111.8-127zM434.7 368a48 48 0 1 1 90.5 32 48 48 0 1 1 -90.5-32zM160 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px;
}

#button-3 .checkbox:checked+.knobs:before {
    content: "";
    left: 42px;
    background-color: #FEC100;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' fill='white'%3E%3Cpath d='M50.7 58.5L0 160l208 0 0-128L93.7 32C75.5 32 58.9 42.3 50.7 58.5zM240 160l208 0L397.3 58.5C389.1 42.3 372.5 32 354.3 32L240 32l0 128zm208 32L0 192 0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-224z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    background-size: 16px;
}

#button-3 .checkbox:checked~.layer {
    background-color: #fcebeb;
}

.advanced-form-placeholder {
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>